import React from 'react';
import { Box, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { getTranslationValue } from '../../../constants/posMenu';
import { POS_COLORS } from './posColors';

/**
 * Categories – ONE horizontal row with horizontal scroll (matches POS client).
 * Colors from POS (posColors.js).
 */
const CAT_BTN_W = 130;
const CAT_BTN_H = 74;

const CategoriesGrid = ({ menuMap, selectedCategory, onSelectCategory }) => {
  const categories = React.useMemo(() => {
    if (!menuMap?.categories) return [];
    return Object.values(menuMap.categories)
      .filter((cat) => cat.isActive !== false)
      .sort((a, b) => (a.sort ?? 0) - (b.sort ?? 0));
  }, [menuMap]);

  if (categories.length === 0) {
    return (
      <Box sx={{ p: 2, textAlign: 'center' }}>
        <Typography variant="body2" color="text.secondary">
          No categories available
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ px: 1, py: 1 }}>
      <Typography
        sx={{
          fontSize: 16,
          fontWeight: 500,
          color: POS_COLORS.BLACK,
          mb: 1,
        }}
      >
        Categories
      </Typography>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          gap: '4px',
          overflowX: 'auto',
          pb: 0.5,
          '&::-webkit-scrollbar': { height: 6 },
          '&::-webkit-scrollbar-thumb': {
            bgcolor: POS_COLORS.GRAY_SLIDE,
            borderRadius: 3,
          },
        }}
      >
        {categories.map((category) => {
          const isSelected = selectedCategory?._id === category._id;
          return (
            <Box
              key={category._id}
              onClick={() => onSelectCategory(category)}
              sx={{
                flexShrink: 0,
                width: CAT_BTN_W,
                height: CAT_BTN_H,
                borderRadius: '12px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                px: 2,
                position: 'relative',
                bgcolor: isSelected
                  ? POS_COLORS.CATEGORY_BG_SELECTED
                  : POS_COLORS.CATEGORY_BG,
                color: POS_COLORS.WHITE,
                cursor: 'pointer',
                transition: 'all 0.15s ease',
                border: 'none',
                '&:hover': { bgcolor: POS_COLORS.CATEGORY_BG_HOVER },
              }}
            >
              {isSelected && (
                <CheckCircleIcon
                  sx={{
                    position: 'absolute',
                    top: 8,
                    right: 8,
                    fontSize: 20,
                    color: POS_COLORS.WHITE,
                  }}
                />
              )}
              <Typography
                sx={{
                  fontWeight: 500,
                  fontSize: 16,
                  textAlign: 'center',
                  wordBreak: 'break-word',
                  display: '-webkit-box',
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: 'vertical',
                  overflow: 'hidden',
                }}
              >
                {getTranslationValue(category.name)}
              </Typography>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default CategoriesGrid;
